// projects/humanresources-personnel/src/assets/i18n/*/hr-per-health.json
export class HrPerHealthKey {
    private static readonly keyPrefix = 'hrPerHealth';
    public static title = `${HrPerHealthKey.keyPrefix}.title`;
    public static pageHeader = `${HrPerHealthKey.keyPrefix}.pageHeader`;
    public static protocolDate = `${HrPerHealthKey.keyPrefix}.protocolDate`;
    public static protocolNumber = `${HrPerHealthKey.keyPrefix}.protocolNumber`;
    public static examination = `${HrPerHealthKey.keyPrefix}.examination`;
    public static examinationDoctorRequest = `${HrPerHealthKey.examination}.doctorRequest`;
    public static examinationPatientRequest = `${HrPerHealthKey.examination}.patientRequest`;
    public static examinationDiagnosticTypeId = `${HrPerHealthKey.examination}.diagnosticTypeId`;
    public static examinationDiagnosticCodeId = `${HrPerHealthKey.examination}.diagnosticCodeId`;
    public static examinationReasonForExamination = `${HrPerHealthKey.examination}.reasonForExamination`;
    public static examinationFinding = `${HrPerHealthKey.examination}.finding`;
    public static examinationExaminationResult = `${HrPerHealthKey.examination}.examinationResult`;
    public static examinationTransferredBranch = `${HrPerHealthKey.examination}.transferredBranch`;
    public static nursingProcedure = `${HrPerHealthKey.keyPrefix}.nursingProcedure`;
    public static periodicExamination = `${HrPerHealthKey.keyPrefix}.periodicExamination`;
    public static examinationEnumReasonForExamination = `${HrPerHealthKey.examination}.enumReasonForExamination`;
    public static examinationTypeEnum = `${HrPerHealthKey.periodicExamination}.examinationTypeEnum`;
}
